import { create } from "zustand"
import { persist } from "zustand/middleware"
import { MEMORY_CHANGED_EVENT } from "@/lib/constants/memory"

// Demo user constants from database seed
export const DEMO_USER = {
  id: "b2c3d4e5-f6a7-8901-bcde-f23456789012",
  email: "mike@apexremodeling.com",
  fullName: "Mike Harrison",
  role: "owner",
}

export const DEMO_TENANT = {
  id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
  name: "Apex Home Remodeling",
  slug: "apex-remodeling",
  settings: {
    industry: "Home Services / Remodeling",
    locations: ["Denver, CO", "Boulder, CO", "Fort Collins, CO"],
    employee_count: "25-50",
    annual_revenue: "$2M-$5M",
    founded: 2018,
  },
}

interface DemoStore {
  isDemoMode: boolean
  activateDemo: () => void
  deactivateDemo: () => void
  toggleDemo: () => void
}

// Helper to emit memory change event when demo mode changes
function emitDemoModeChange() {
  if (typeof window !== "undefined") {
    // Small delay to ensure state is updated
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent(MEMORY_CHANGED_EVENT))
    }, 10)
  }
}

export const useDemoStore = create<DemoStore>()(
  persist(
    (set) => ({
      isDemoMode: false,
      activateDemo: () => {
        set({ isDemoMode: true })
        emitDemoModeChange()
      },
      deactivateDemo: () => {
        set({ isDemoMode: false })
        emitDemoModeChange()
      },
      toggleDemo: () => {
        set((state) => {
          emitDemoModeChange()
          return { isDemoMode: !state.isDemoMode }
        })
      },
    }),
    {
      name: "biziq-demo-mode",
    },
  ),
)

// Non-reactive getter for use outside React components
export function getIsDemoMode(): boolean {
  if (typeof window === "undefined") return false
  try {
    const stored = localStorage.getItem("biziq-demo-mode")
    if (stored) {
      const parsed = JSON.parse(stored)
      return parsed?.state?.isDemoMode ?? false
    }
  } catch {
    // Ignore parse errors
  }
  return false
}
